export default __webpack_public_path__ + "static/media/HeroImageCartoes.3fd6f4c2.png";